import React from 'react';

import MedicalAccordion from './MedicalAccordion';
import { MedicalMeasuresProps } from './MedicalMeasures.types';


const MedicalMeasures = ({ allDeviceExams, consultationDate, bloodPressureIcon, oximetryIcon, temperatureIcon, glucoseIcon, ecgIcon, otherMedicalMeasurementIcon }: MedicalMeasuresProps) => {
  const iconMap = {
    blood_pressure: bloodPressureIcon,
    oximetry: oximetryIcon,
    glucose: glucoseIcon,
    temperature: temperatureIcon,
    ecg: ecgIcon,
    other_medical_measurement: otherMedicalMeasurementIcon,
  };

  return (
    <div className='md__container'>
      {Object.entries(allDeviceExams).map(([type, measures]) => {
        return (
          <MedicalAccordion
            key={type}
            type={type}
            icon={iconMap[type]}
            measuresForType={measures}
            consultationDate={consultationDate}
            className='fullWidth'
          />
        );
      })}
    </div>
  );
};

export default MedicalMeasures;
